export default __webpack_public_path__ + "static/media/close-white.9c366229.svg";